import { LoadableAfterPaint } from '@confluence/loadable';
import { WatchButtonPlaceholder } from '../src/WatchButtonPlaceholder';

export const WatchDialog = LoadableAfterPaint<any>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-watch-dialog" */ '../src/WatchDialog'))
			.WatchDialog,
	loading: WatchButtonPlaceholder,
});
